import { getInitialState, getPath } from "../../utils";

const initialState = {
  issueTypeList: [],
  nextPage: -1,
  prevPage: -1,
  currentPage: 1,
  issueArea: [],
  issueTypeDetails: {},
  activeFilters: {},
  remoteSearch: {
    nextPage: 2,
    prevPage: -1,
    currentPage: 1,
    issueTypeList: [],
  },
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "SET_ISSUE_TYPE_LIST":
      return setIssueTypeList(state, action);
    case "SET_CURRENT_PAGE_ISSUE_TYPE":
      return setCurrentPageIssueType(state, action);
    case "SET_ISSUE_AREA":
      return setIssueArea(state, action);
    case "SET_ISSUE_TYPE_DETAILS":
      return setIssueTypeDetails(state, action);
    case "SET_ISSUE_TYPE_ACTIVE_FILTERS":
      return setActiveFilters(state, action);
    case "SET_ISSUE_TYPE_LIST_REMOTE_SEARCH": {
      return setIssueTypeListRemoteSearch(state, action);
    }
    default:
      return state;
  }
}

const setIssueTypeList = (state, action) => {
  const issueTypeList = getPath(action.payload, "data", []);

  const uniqueMap = new Map();

  issueTypeList.forEach((item) => {
    if (item.id) {
      uniqueMap.set(Number(item.id), item);
    }
  });

  const uniqueList = Array.from(uniqueMap.values());

  return {
    ...state,
    issueTypeList: uniqueList,
    nextPage: getPath(action.payload, "PageResponse.nextPage", -1),
    prevPage: getPath(action.payload, "PageResponse.previousPage", -1),
  };
};

const setIssueTypeListRemoteSearch = (state, action) => {
  const data = getPath(action.payload, "data", []);
  data.forEach((item, index) => {
    data[index].issue = item.name;
  });
  return {
    ...state,
    remoteSearch: {
      issueTypeList: data,
      nextPage: getPath(action.payload, "PageResponse.nextPage", -1),
      prevPage: getPath(action.payload, "PageResponse.previousPage", -1),
    },
  };
};

const setCurrentPageIssueType = (state, action) => {
  return {
    ...state,
    currentPage: action.payload,
  };
};
const setIssueArea = (state, action) => {
  return {
    ...state,
    issueArea: getPath(action.payload, "IssueAreas", []),
  };
};
const setIssueTypeDetails = (state, action) => {
  return {
    ...state,
    issueTypeDetails: getPath(action.payload, "data", {}),
  };
};

const setActiveFilters = (state, action) => {
  return {
    ...state,
    activeFilters: action.payload,
  };
};
